<template>
  <div>
    <el-dialog title="实名认证" :visible="dialogAuth" :close-on-click-modal="false" :show-close="!force" width="400px"
      @close="cancel">
      <div>
        <div class="item">
          <div class="label">姓名</div>
          <div>
            <el-input v-model="name" placeholder="请输入姓名"></el-input>
          </div>
        </div>
        <div class="item">
          <div class="label">身份证号</div>
          <div>
            <el-input v-model="idCard" placeholder="请输入身份证号"></el-input>
          </div>
        </div>
        <div class="item">
          <div class="label">手机号</div>
          <div>
            <el-input v-model="phone" type="number" placeholder="请输入手机号"></el-input>
          </div>
        </div>
        <div class="code_box">
          <div class="item">
            <div class="label">验证码</div>
            <div>
              <el-input v-model="code" type="number" placeholder="请输入验证码"></el-input>
            </div>
          </div>
          <div :class="['send_btn',sendOk?'sended':'']" @click="sendCode">{{text}}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel" v-if="!force">取 消</el-button>
        <el-button @click="logout" v-if="out">退出登录</el-button>
        <el-button type="primary" @click="confirmBind">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    sendSms,
    realauth
  } from "@/api/my";
  export default {
    data() {
      return {
        name: '',
        idCard: "",
        phone: '',
        code: '',
        sendOk: false,
        second: 60,
        timer: null,
        text: '获取验证码'
      }
    },
    watch: {
      dialogAuth(n, o) {
        if (!n) {
          if (this.timer) {
            this.sendOk = false
            this.text = '获取验证码'
            this.second = 60
            clearInterval(this.timer)
          }
        } else {
          this.name = ''
          this.idCard = ''
          this.phone = ''
          this.code = ''
        }
      }
    },
    props: {
      dialogAuth: {
        default: false
      },
      userInfo: {
        default: {}
      },
      force: {
        default: false
      },
      out: {
        default: false
      }
    },
    methods: {
      cancel() {
        this.$emit('update:dialogAuth', false)
      },
      logout() {
        localStorage.removeItem("token");
        let adminUser = localStorage.getItem('adminUser')
        if (adminUser) {
          localStorage.removeItem('adminUser')
        }
        this.$router.push({
          name: "login"
        });
      },
      sendCode() {
        if (!this.phone) {
          this.$message({
            message: '手机号不能为空',
            type: 'warning'
          });
          return
        }
        if (this.sendOk) {
          return
        }
        sendSms({
          type: 'bind_phone',
          mobile_phone: this.phone
        }).then(res => {
          if (res.code === 200) {
            this.$message({
              message: res.msg,
              type: "success"
            });
            this.timer = setInterval(() => {
              if (this.second <= 0) {
                clearInterval(this.timer)
                this.sendOk = false
                this.text = '获取验证码'
                this.second = 60
                return
              }
              this.sendOk = true
                --this.second
              this.text = `${this.second}s`
            }, 1000)
          }
        })
      },
      confirmBind() {
        if (!this.name) {
          this.$message({
            message: '请输入姓名',
            type: 'warning'
          });
          return
        }
        if (!this.$tools.checkIdCard(this.idCard)) {
          this.$message({
            message: '请输入正确的身份证号',
            type: 'warning'
          });
          return
        }
        if (!this.userInfo.mobile_phone) {
          if (!this.phone) {
            this.$message({
              message: '手机号不能为空',
              type: 'warning'
            });
            return
          }
          if (!this.code) {
            this.$message({
              message: '验证码不能为空',
              type: 'warning'
            });
            return
          }
        }
        realauth({
          real_name: this.name,
          id_card: this.idCard,
          mobile_phone: this.phone,
          code: this.code
        }).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '恭喜您认证成功',
              type: "success"
            });
            this.$emit('update:dialogAuth', false)
            this.$tools.refUserinfo()
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .code_box {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;

    .send_btn {
      width: 100px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      font-size: 14px;
      border-radius: 40px;
      background-color: #5adfab;
      color: white;
      flex-shrink: 0;
      margin-left: 20px;
      cursor: pointer;
    }

    .sended {
      background-color: #E4E4E4;
    }
  }

  .item {
    display: flex;
    margin-top: 20px;
    font-size: 15px;
    background-color: #F3F6F5;
    align-items: center;
    padding: 0 20px;
    box-sizing: border-box;

    /deep/ .el-input__inner {
      background-color: #F3F6F5;
      border: none;
    }

    &:first-child {
      margin-top: 0;
    }

    .label {
      width: 62px;
      flex-shrink: 0;
    }
  }
</style>


// WEBPACK FOOTER //
// src/component/my/auth_name.vue